import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IDefectActBrand } from './interfaces';

export const getDefectActBrandList = (data: IDynamicTableParams) => {
  return instance()
    .post<IDefectActBrand[]>('/defectActBrand/list', data)
    .then((response) => response.data);
};

export const getDefectActBrandListAll = () => {
  return instance()
    .post<IDefectActBrand[]>('/defectActBrand/listAll')
    .then((response) => response.data);
};

export const getDefectActBrandListAllNotDeleted = () => {
  return instance()
    .get<IDefectActBrand[]>('/defectActBrand/listAllNotDeleted')
    .then((response) => response.data);
};

export const getDefectActBrandAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/defectActBrand/availableColumns')
    .then((response) => response.data);
};

export const getDefectActBrandAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/defectActBrand/availableGroupColumns')
    .then((response) => response.data);
};

export const loadDefectActBrand = (defectActBrandId: number) => {
  return instance()
    .get<IDefectActBrand>(`/defectActBrand/load/${defectActBrandId}`)
    .then((response) => response.data);
};

export const createDefectActBrand = (defectActBrand: IDefectActBrand) => {
  return instance()
    .post<IDefectActBrand>(`/defectActBrand/save`, defectActBrand)
    .then((response) => response.data);
};

export const updateDefectActBrand = (defectActBrandId: number, defectActBrand: IDefectActBrand) => {
  return instance()
    .post<IDefectActBrand>(`/defectActBrand/update/${defectActBrandId}`, defectActBrand)
    .then((response) => response.data);
};

export const archiveDefectActBrand = (defectActBrandId: number) => {
  return instance()
    .post(`/defectActBrand/archive/${defectActBrandId}`)
    .then((response) => response.data);
};

export const recoverDefectActBrand = (defectActBrandId: number) => {
  return instance()
    .post(`/defectActBrand/recover/${defectActBrandId}`)
    .then((response) => response.data);
};
